import React, { useContext } from "react"

import { makeStyles } from "@material-ui/core/styles"
import { ButtonBase, Typography } from "@material-ui/core"
import { CartContext } from ".."

const useStyles = makeStyles(theme => ({
  button: {
    flexDirection: props => props.reversed && "row-reverse",
    padding: theme.spacing(1),
    [theme.breakpoints.down("md")]: {
      marginRight: theme.spacing(4),
      marginLeft: theme.spacing(4),
    },
  },
  shoppingBagImage: {
    height: theme.spacing(3.5),
    width: theme.spacing(3.5),
  },
  cartCount: {
    alignItems: "center",
    backgroundColor: props => props.count && theme.palette.green.main,
    borderRadius: "50%",
    color: theme.palette.green.contrastText,
    display: "flex",
    height: theme.spacing(3.5),
    justifyContent: "center",
    marginLeft: props => !props.reversed && theme.spacing(0.5),
    marginRight: props => props.reversed && theme.spacing(0.5),
    width: theme.spacing(3.5),
    position: "absolute",
    left: theme.spacing(4.125),
  },
}))

export default props => {
  const { count } = useContext(CartContext)
  const classes = useStyles({ count, ...props })
  const ShoppingBag = props.cartLogo
  let countComponent
  if (count && count > 0) {
    countComponent = (
      <Typography
        data-cy="cart-count"
        variant={"button"}
        classes={{ root: classes.cartCount }}
      >
        {count}
      </Typography>
    )
  }
  return (
    <ButtonBase
      disableRipple
      classes={{ root: classes.button }}
      onClick={props.onClick}
    >
      <img
        src={ShoppingBag}
        className={classes.shoppingBagImage}
        alt="Shopping Bag"
      />
      {countComponent}
    </ButtonBase>
  )
}
